import React, { useEffect } from 'react';
import Modal from 'react-modal';

import styles from './StandardModal.module.scss';

let appElementSet = false;

const StandardModal = ({
  isOpen,
  contentLabel,
  onRequestClose,
  children
}) => {
  useEffect(() => {
    if (!appElementSet) {
      const appContainer = document.getElementById('appContainer');
      if (appContainer) {
        Modal.setAppElement('#appContainer');
        appElementSet = true;
      }
    }
  }, []);

  return (
    <Modal
      isOpen={isOpen}
      contentLabel={contentLabel}
      onRequestClose={onRequestClose}
      className={styles.modal}
      overlayClassName={styles.overlay}
      shouldCloseOnOverlayClick={true}
    >
      {children}
    </Modal>
  );
};

export default StandardModal;
